import React from 'react';
import Entry from '../entry';
import { Text, Flex } from 'rebass';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

export default () => {
  const title = '6. Splunk';
  const flag = 'Kent you are so unfair. And we were going to make you the king of the Winter Carnival.';
  const hints = [(<Text>[Professor Banas Chat] Hi, I'm Dr. Banas, professor of Cheerology at Elf University.

This term, I'm teaching "HOL 404: The Search for Holiday Cheer in Popular Culture," and I've had quite a shock!

I was at home enjoying a nice cup of Gløgg when I had a call from Kent, one of my students who interns at the Elf U SOC.

Kent said that my computer has been hacking other computers on campus and that I needed to fix it ASAP!

If I don't, he will have to report the incident to the boss of the SOC.

Apparently, I can find out more information from this website https://splunk.elfu.org/ with the username: elf / Password: elfsocks.

I don't know anything about computer security. Can you please help me?</Text>),
(<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[Talk by James Brodsky]</Text><a rel="noopener noreferrer" target="_blank" href='https://www.youtube.com/watch?v=qbIhHhRKQCw'> Dashing Through the Logs</a></Flex>)];
  const assignment = 'Access https://splunk.elfu.org/ as elf with password elfsocks. What was the message for Kent that the adversary embedded in this attack? The SOC folks at that link will help you along! For hints on achieving this objective, please visit the Laboratory in Hermey Hall and talk with Prof. Banas.';
  const data = useStaticQuery(graphql`
    query {
      o6search1: file(relativePath: { eq: "o6search1.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      o6omgSearch2: file(relativePath: { eq: "o6omgSearch2.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      o6email1: file(relativePath: { eq: "o6email1.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      o6email2: file(relativePath: { eq: "o6email2.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      splunAnswer: file(relativePath: { eq: "splunAnswer.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }

    }
  `);
  return (
    <Entry
      title={title}
      hints={hints}
      flag={flag}
      assignment={assignment}
    >
      <Text my={2}>As suggested in the video, we will start by looking at <code>stoq</code> with Splunk query</Text>
      <Img fluid={data.o6search1.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '8vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>on the results we look through <code>{`results{}.workers.smtp.body`}</code> and find something interesting.</Text>
      <Flex flexDirection='row' justifyContent='center' alignItems='flex-start'>
        <Img fluid={data.o6email1.childImageSharp.fluid}
                style={{ margin: 0,  maxHeight: '70vh', width: '35vw' }}
                imgStyle={{ objectFit: 'contain' }}
        />
        <Img fluid={data.o6email2.childImageSharp.fluid}
                style={{ margin: 0,  maxHeight: '70vh', width: '35vw' }}
                imgStyle={{ objectFit: 'contain' }}
        />
      </Flex>
      <Text my={2}>An attacker wants Professor Banas to open a .zip file and to Enable Editing. That looks like the attacker placed malicious code in Microsoft Office Macro. Let look into this .zip file with Splunk query</Text>
      <Img fluid={data.o6omgSearch2.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '8vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <Text my={2}>The query returned one result. In that result we will look through all <code>{`results{}.archivers.filedir.path`}</code>. If we look at path <code>	/home/ubuntu/archive/f/f/1/e/a/ff1ea6f13be3faabd0da728f514deb7fe3577cc4</code> in the "File Archive" section of splink, we discover thath this filecontains the answer:</Text>
      <Img fluid={data.splunAnswer.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
    </Entry>
  )

};


// sourcetype=stoq "results{}.workers.exif.filetype"=zip

// professor banas, i have completed my assignment. please open the attached zip file with password 123456789 and then open the word document to view it. you will have to click \"enable editing\" then \"enable content\" to see it. this was a fun assignment. i hope you like it!  --bradly buttercups
